import * as PIXI from "pixi.js";
import loliCrying1Image from "../assets/loli_crying1.png";
import loliCrying2Image from "../assets/loli_crying2.png";
import loliSmilingImage from "../assets/loli_smiling.png";
import { charaSize } from "../constants";
import { LoadManager } from "../managers/loadManager";
import { LoliManager } from "../managers/loliManager";

export function loadLoliAssets(loadManager: LoadManager) {
  return {
    crying1: loadManager.loadTexture(loliCrying1Image),
    crying2: loadManager.loadTexture(loliCrying2Image),
    smiling: loadManager.loadTexture(loliSmilingImage),
  } as const;
}

type SetupLoliProps = Readonly<{
  loliAssets: ReturnType<typeof loadLoliAssets>;
  parent: PIXI.Container;
  ticker: PIXI.Ticker;
  loliManager: LoliManager;
  x: number;
  y: number;
}>;

export function setupLoli({
  loliAssets,
  parent,
  ticker,
  loliManager,
  x,
  y,
}: SetupLoliProps) {
  const loli = new PIXI.Sprite(loliAssets.crying1.get());
  loli.width = charaSize * 2;
  loli.height = charaSize * 2;
  loli.anchor.set(0.5, 0.5);
  loli.x = x;
  loli.y = y;

  const onTick = () => {
    if (loliManager.emotion === "cry") {
      const animationState = Math.floor(performance.now() / 500) & 1;
      if (animationState) {
        loli.texture = loliAssets.crying1.get();
      } else {
        loli.texture = loliAssets.crying2.get();
      }
    } else {
      loli.texture = loliAssets.smiling.get();
    }
  };

  parent.addChild(loli);
  ticker.add(onTick);
  const dispose = () => {
    parent.removeChild(loli);
    ticker.remove(onTick);
  };

  return dispose;
}
